<div class="landscape-view-mobile" style="display: none;">
  <div class="content-wrapper">
    <div><img loading="lazy" data-src="/assets/images/homepage/landscape-img-mobile.png?w=auto" width="100" height="85" alt="Small device landscape image" /></div>
    <h2>Please rotate your device</h2>
    <p>We don't support landscape mode yet. Please go back to portrait mode for the best experience</p>
   </div>
</div>